import { Control } from "./controls";
import { TreeNodeV } from "./tree";
import * as t from "io-ts";

export type ClipboardStatus = {
  secure: Window["isSecureContext"];
  permission: PermissionStatus | null;
};

const ElementClipboardDataV = t.union([TreeNodeV, t.array(TreeNodeV)]);

const ControlSectionPropertiesDataClipboardDataV = t.type({
  controlSectionShapeHash: t.string,
  propertiesData: t.type({
    propertiesData: t.unknown
  })
});

export const ClipboardDataV = t.partial({
  element: ElementClipboardDataV,
  controlSectionPropertiesData: ControlSectionPropertiesDataClipboardDataV
});

export type ClipboardData = t.TypeOf<typeof ClipboardDataV>;

export type ElementStudioClipboard = {
  copiedControl: false | Control;
};
